import { Routes } from '@angular/router';
import { authRedirectGuard } from './shared/guard/auth-redirect.guard';

export const routes: Routes = [
  {
    path: 'auth',
    loadChildren: () => import('./auth/auth.routes').then((m) => m.authRoutes),
  },
  {
    path: 'pages',
    loadChildren: () =>
      import('./pages/pages.routes').then((m) => m.pagesRoutes),
  },
  {
    path: 'content',
    loadChildren: () =>
      import('./dashboard/dashboard.routes').then((m) => m.dashboardRoutes),
  },
  // {
  //   path: '',
  //   redirectTo: 'auth',
  //   pathMatch: 'full',
  // },
  {
    path: '',
    canActivate: [authRedirectGuard],
    children: [],
    pathMatch: 'full',
  },
  {
    path: '**',
    redirectTo: 'auth',
  },
];
